import arrayRouterPaths from './arrayRouterPaths';

export default arrayRouterPaths;
